module.exports = __webpack_public_path__ + "static/5i-335c9c91b108673bd54f574969c1b7ae.woff";